/*
 * @Author: xiaoxi 2767862556@qq.com
 * @Date: 2022-06-01 11:19:37
 * @LastEditors: B9NB10465295
 * @LastEditTime: 2022-06-27 17:33:05
 * @FilePath: \webpatient\src\utils\hospitalConfig.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export const hospitalMapByDomain={
  "www.cdboehospital.com":{
    code:"H05",
    domain:"cd",
    templateNo:"h05-website",
    sys:"ohealth"
  },
  "www.szboehospital.com":{
    code:"H06",
    domain:"sz",
    templateNo:"ohealth-code",
    sys:"ohealth"
  },
  "www.hfboehospital.com":{
    code:"H02",
    domain:"hf",
    // templateNo:"h02site-code",
    // sys:"h02site"
    templateNo:"ohealth-code",
    sys:"ohealth"
  },
  // 合肥测试域名
  "hfboehospitaltest.boe.com.cn":{
    code:"H02",
    domain:"hf",
    // templateNo:"h02site-code",
    // sys:"h02site"
    templateNo:"ohealth-code",
    sys:"ohealth"
  },
  // 成都新域名
  "cdhospital.boe.com":{
    code:"H05",
    domain:"cd",
    templateNo:"h05-website",
    sys:"ohealth"
  },
  // 苏州新域名
  "szhospital.boe.com":{
    code:"H06",
    domain:"sz",
    templateNo:"ohealth-code",
    sys:"ohealth"
  },
  // 合肥新域名
  "hfhospital.boe.com":{
    code:"H02",
    domain:"hf",
    templateNo:"ohealth-code",
    sys:"ohealth"
  },
  
}